import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PawTrail } from './PawTrail';
import { assets } from '../data/landing';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" className="relative overflow-hidden pb-8 pt-8 sm:pb-12 sm:pt-12" data-id="element-62" data-mp="4lyxkshw2qgt">
      <PawTrail count={4} className="absolute left-[4%] top-40 hidden lg:flex" data-id="element-63" data-mp="129h1nq0lv4eh" />
      <PawTrail count={3} className="absolute bottom-10 right-[5%] hidden lg:flex" tone="gold" data-id="element-64" data-mp="127ed7af3pjbv" />

      <div className="relative z-10 mx-auto grid max-w-6xl items-center gap-8 px-5 sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14" data-id="element-65" data-mp="x8b7rov7lb3d">
        <div className="text-center lg:text-left" data-id="element-66" data-mp="ncgiiawhchrm">
          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          ease
        }} className="font-sans text-sm font-semibold text-gold-dark" data-id="element-67" data-mp="nbyhl0yvhfdd">
            Una app para empezar tu negocio de cuidado y paseo de perros
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.28,
          ease,
          delay: 0.05
        }} className="mt-4 font-display text-[2.25rem] font-semibold leading-[1.06] tracking-tight text-petrol sm:text-5xl lg:text-[3.5rem]" data-id="element-68" data-mp="3o7lvm11r3otp">
            De "me encantan los perros" a tu primer cliente pagando.
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.28,
          ease,
          delay: 0.1
        }} className="mx-auto mt-5 max-w-xl font-sans text-lg leading-relaxed text-petrol/75 lg:mx-0" data-id="element-69" data-mp="3599ki9ra44vh">
            Pawsy Emprende te lleva paso a paso: aprendé lo esencial, armá tu servicio y tu precio,
            conseguí tus primeros clientes y organizá tu trabajo. Todo desde una sola app.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.28,
          ease,
          delay: 0.14
        }} className="mt-7" data-id="element-70" data-mp="s2joa067q6l3">
            <CtaButton size="lg" href="#precio" pixelEvent="" className="w-full sm:w-auto" data-id="element-71" data-mp="ibgjana5x7gj">
              🐾 Quiero empezar
              <ArrowRightIcon className="h-5 w-5" strokeWidth={2.4} aria-hidden="true" data-id="element-72" data-mp="deq92gl1h631" />
            </CtaButton>
            <p className="mt-3.5 font-sans text-sm text-petrol-muted" data-id="element-73" data-mp="1b049mx9rqn0y">
              Pago único. Sin suscripción mensual.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease,
        delay: 0.12
      }} className="mx-auto w-full max-w-md lg:max-w-none" data-id="element-74" data-mp="111esj6pp56lr">
          <img src={assets.heroPhoto} alt="Paseadora cruzando la senda peatonal con tres perros pequeños atados a sus correas" className="block h-auto w-full rounded-[1.75rem] shadow-card" decoding="async" data-id="element-75" data-mp="3lqm4i498ffxk" />
        </motion.div>
      </div>
    </section>;
}